import store from '@/store';

function hasRole(...roles) {
    if (!roles.flat().length) {
        return true;
    }
    const userRoles = new Map(store.getters['AuthenticationStore/mappedRoles']);

    return roles.flat().some((role) => userRoles.has(role));
}

function doesntHaveRole(...roles) {
    if (!roles.flat().length) {
        return false;
    }
    const userRoles = new Map(store.getters['AuthenticationStore/mappedRoles']);

    return !roles.flat().some((role) => userRoles.has(role));
}

export function isDisabled() {
    return this.disabled || this.$authorization.doesntHaveRole(this.allowedRoles);
}

export const roles = {
    ACCOUNT_MANAGER: 'account_manager',
    AP_ADMIN: 'ap_admin',
    AR_ADMIN: 'ar_admin',
    BILLING_ADMIN: 'billing_admin',
    CHEMICAL_ADMIN: 'chemical_admin',
    CUSTOMER_ADMIN: 'customer_admin',
    ENGINEER: 'engineer',
    EXCHANGE_ADMIN: 'exchange_admin',
    EXCHANGE_DRIVER: 'exchange_driver',
    HR_EMPLOYEE: 'hr_employees',
    INSIDE_SALES: 'inside_sales',
    ITEM_ADMIN: 'item_admin',
    JOB_ADMIN: 'job_admin',
    JOB_TIME_TRACKING: 'job_time_tracking',
    LOGISTICS_ADMIN: 'logistics_admin',
    ONBOARDING: 'onboarding',
    PRINTER_ADMIN: 'printer_admin',
    PROPOSAL_AUTHOR: 'proposal_author',
    PURCHASING: 'purchasing',
    SERVICE_ADMIN: 'service_admin',
    SERVICE_MANAGER: 'service_manager',
    SERVICE_TECHNICIAN: 'service_technician',
    SERVICE_WATERLINX_ADMIN: 'water_linx_admin',
    SETTINGS_ADMIN: 'settings_admin',
    SHIPPING_ADMIN: 'shipping_admin',
    SYSTEM_ADMIN: 'system_admin',
    WATER_SYSTEM_ADMIN: 'water_system_admin',
};

export const authorization = {
    hasRole,
    doesntHaveRole,
    roles,
};

const XlinxPermissions = {
    install(app) {
        // eslint-disable-next-line no-param-reassign
        app.config.globalProperties.$authorization = authorization;
    },
};

export default XlinxPermissions;
